<template>
  <v-container fluid="fluid">
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t('labels.filters') }}</h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip class="ml-1 pointer" bottom="bottom"><template slot="activator">
            <v-btn flat="flat" @click="reset" icon="icon">
              <v-icon>autorenew</v-icon>
            </v-btn>
          </template><span>Reset</span></v-tooltip>
        <v-tooltip class="ml-1 pointer" bottom="bottom"><template slot="activator">
            <v-btn flat="flat" @click="reloadData" icon="icon">
              <v-icon>refresh</v-icon>
            </v-btn>
          </template><span>Fetch Data</span></v-tooltip>
      </v-toolbar>
      <v-card-text>
        <v-layout row="row" wrap="wrap">
          <v-flex xs12="xs12" sm6="sm6">
            <VueCtkDateTimePicker v-model="setDate" label="Select Date Range" range="range" @input="setDateTime">
            </VueCtkDateTimePicker>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-card class="mt-2">
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t('pageHeader.prepaid') }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-text-field v-model="search" prepend-icon="search" label="Search" clearable="clearable"
          single-line="single-line" hide-details="hide-details"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" item-key="id" :items="prepaid" :search="search" :loading="loading"
        :pagination.sync="pagination"><template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left">{{ props.item.creditID }}</td>
            <td class="text-xs-left">
              <div>{{ $moment(props.item.createDateTime).format('MM/DD/YYYY h:m a') }}</div>
              <div v-if="props.item.chargeId"><span>Charged ID</span>
                <v-tooltip class="ml-1 pointer" bottom><template slot="activator"><a @click="openStripe(props.item.chargeId)">
                      {{ props.item.chargeId }}
                    </a></template><span>View on stripe</span></v-tooltip>
              </div>
            </td>
            <td class="text-xs-left"><a @click="open(props.item)">{{ props.item.Store.CSPID }}</a></td>
            <td class="text-xs-left">{{ props.item.Store.businessName }}</td>
            <td class="text-xs-left">{{ props.item.userName }}</td>
            <td class="text-xs-left">{{ props.item.refID }}</td>
            <td class="text-xs-right">{{ props.item.amount | currency }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no
          results.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import walletService from '../service.js'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
// import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { mapActions } from 'vuex';

export default {
  name: "wallet-list",
  data() {
    return {
      setDate: {
        start: this.$moment(new Date()).subtract(30, 'days'),
        end: this.$moment(new Date())
      },
      filter: {
        fromDate: this.$moment(new Date()).subtract(30, 'days').format("MM/DD/YYYY h:m a"),
        toDate: this.$moment(new Date()).format("MM/DD/YYYY h:m a")
      },
      headers: [
        {
          text: this.$t('labels.id'),
          value: 'creditID',
          sortable: true,
          width: '5%',
        },
        {
          text: this.$t('labels.createdAt'),
          value: 'createDateTime',
          sortable: true,
          width: '15%',
        },
        {
          text: this.$t('labels.cspid'),
          value: 'Store.CSPID',
          sortable: true,
        },
        {
          text: this.$t('labels.storeName'),
          value: 'Store.businessName',
          sortable: true,
        },
        {
          text: this.$t('labels.userName'),
          value: 'userName',
          sortable: true,
        },
        {
          text: this.$t('labels.refNumber'),
          value: 'refID',
          sortable: true,
        },
        {
          text: this.$t('labels.amount'),
          value: 'amount',
          sortable: true,
        },
      ],
      search: null,
      prepaid: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'creditID',
        descending: true,
      },
    }
  },
  components: {
    VueCtkDateTimePicker
  },
  created() {
    this.getList()
  },
  watch: {
    location() {
      this.getByStoreId()
    }
  },
  methods: {
    ...mapActions('global', ['setPageTitle']),
    openStripe(id) {
      window.open(
        // https://dashboard.stripe.com/test/payments/ch_2NDoHEhVM1YjUJRN0rc9nnVh
        `https://dashboard.stripe.com/test/payments/${id}`,
        '_blank',
      );
    },
    reset() {
      this.resetList()
      this.getList()
    },
    open(data) {
      this.$router.push({ path: `/location/profile/${data.Store.storeID}` })
    },
    setDateTime(val) {
      this.filter.fromDate = this.$moment(val.start).format("MM/DD/YYYY h:m a")
      this.filter.toDate = this.$moment(val.end).format("MM/DD/YYYY h:m a")
    },
    resetList() {
      this.filter.fromDate = this.$moment(new Date()).subtract(30, 'days')
      this.filter.toDate = this.$moment(new Date())
    },
    reloadData() {
      this.loading = true
      let proFilter = {}
      if (this.filter.fromDate)
        proFilter.fromDate = this.$moment(this.filter.fromDate).format("MM/DD/YYYY h:m a")
      if (this.filter.toDate)
        proFilter.toDate = this.$moment(this.filter.toDate).format("MM/DD/YYYY h:m a")

      return walletService.getAll(proFilter).then(response => {
        this.prepaid = response.data;
        this.loading = false
        return response
      })
    },
    getList() {
      this.loading = true;
      let proFilter = {}
      if (this.filter.fromDate)
        proFilter.fromDate = this.$moment(this.filter.fromDate).format("MM/DD/YYYY h:m a")
      if (this.filter.toDate)
        proFilter.toDate = this.$moment(this.filter.toDate).format("MM/DD/YYYY h:m a")
      return walletService.getAll(proFilter).then(response => {
        console.log('response', response)
        this.prepaid = response.data;
        this.loading = false;
        return response;
      });
    },
  }
}
</script>

